import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "content"]
  static values = {
    visibleCount: { type: Number, default: 6 }
  }

  connect() {
    this.showLoader()
    this.trackImageLoading()
  }

  showLoader() {
    this.overlayTarget.classList.remove("hidden")
    this.contentTarget.classList.add("hidden")
  }

  hideLoader() {
    this.overlayTarget.classList.add("opacity-0")
    this.contentTarget.classList.remove("hidden")
    
    // Remove overlay after fade animation
    setTimeout(() => {
      this.overlayTarget.classList.add("hidden")
      this.overlayTarget.classList.remove("opacity-0")
    }, 300)
  }

  trackImageLoading() {
    const images = Array.from(this.contentTarget.querySelectorAll("img"))
    const visibleImages = images.slice(0, this.visibleCountValue)
    let loadedImages = 0
    const totalVisibleImages = visibleImages.length

    if (totalVisibleImages === 0) {
      this.hideLoader()
      return
    }

    const onImageLoad = () => {
      loadedImages++
      if (loadedImages === totalVisibleImages) {
        this.hideLoader()
        this.loadRemainingImages(images.slice(this.visibleCountValue))
      }
    }

    visibleImages.forEach(img => {
      if (img.complete) {
        onImageLoad()
      } else {
        img.addEventListener("load", onImageLoad)
        img.addEventListener("error", onImageLoad)
      }
    })
  }

  loadRemainingImages(remainingImages) {
    remainingImages.forEach(img => {
      if (!img.complete) {
        img.addEventListener("load", () => {})
        img.addEventListener("error", () => {})
      }
    })
  }
} 